import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import FormControlLabel, { FormControlLabelProps } from '@material-ui/core/FormControlLabel'

import * as config from 'styles/tailwind.config'

interface IProps {
  label?: any
  checked?: boolean
  value?: string | number
  required?: boolean
  error?: string
  onChange?: (value: boolean) => void
}

const StyledCheckbox = withStyles({
  root: {
    color: config.theme.colors.black,
    '&$checked': {
      color: config.theme.colors.black,
    },
    padding: 0,
    marginRight: 10,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
})((props: CheckboxProps) => <Checkbox color="default" {...props} />)

const StyledFormControlLabel = withStyles({
  root: {
    margin: 0,
  },
})((props: FormControlLabelProps) => <FormControlLabel {...props} />)

const CheckBox: React.FC<IProps> = props => {
  const { label, checked, value, required, onChange, error } = props

  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target

    if (onChange) {
      onChange(checked)
    }
  }

  return (
    <StyledFormControlLabel
      label={
        <span
          className={`${
            error ? 'text-red' : 'text-black'
          } font-400 tracking-0.1 text-13 leading-19`}
        >
          {label}
        </span>
      }
      control={
        <StyledCheckbox
          checked={checked}
          onChange={handleToggle}
          value={value}
          required={required}
          icon={
            <CheckBoxOutlineBlankIcon
              style={{
                color: error ? config.theme.colors.red : config.theme.colors.black,
              }}
              fontSize="small"
            />
          }
          checkedIcon={
            <CheckBoxIcon
              style={{
                color: error ? config.theme.colors.red : config.theme.colors.black,
              }}
              fontSize="small"
            />
          }
        />
      }
    />
  )
}

export default CheckBox
